import { WrapperComponent, ListArticleCard } from '../../../_imports.js';
import './blog_feed.css';

function BlogFeed({ recruiterPosts, candidatePosts }) {
    return (
        <WrapperComponent>
            <section className="blog-split-feed">
                {/* Recruiter Column */}
                <div className="feed-column recruiter">
                    <h2 className="feed-title recruiter">Para Recrutadores</h2>
                    {recruiterPosts.map(post => (
                        <ListArticleCard key={post.id} post={post} rootClassName="feed-card" />
                    ))}
                </div>

                {/* Candidate Column */}
                <div className="feed-column candidate">
                    <h2 className="feed-title candidate">Para Candidatos</h2>
                    {candidatePosts.map(post => (
                        <ListArticleCard key={post.id} post={post} rootClassName="feed-card" />
                    ))}
                </div>
            </section>
        </WrapperComponent>
    );
};

export default BlogFeed;
